/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import * as React from "react"
import Layout from "./src/components/layout"

/**
 * Wrap every page with a persistent Layout instance in the browser.
 */
export const wrapPageElement = ({ element }) => <Layout>{element}</Layout>
